export class Timeouts {
    static SdkInternalDefault: number = 5 * 1000;

    static SdkOpenApp: number = 10 * 1000;
    static SdkCloseApp: number = 35 * 1000;

    static WaitProcessStartedTime: number = 30 * 1000;
    static WaitPaymentAddedTime: number = 60 * 1000;
    static WaitPaymentCompletedTime: number = 60 * 1000;

    static ResetTimerThrottle: number = 10_000;

    /**
     * Timeout for waiting SDK result from cash acceptor (via Common App SDK)
     * @static
     * @type {number}
     * @memberof Timeouts
     */
         static SdkCashReceiving: number = 30 * 60 * 1000;

    /**
     * Default timeout for all Common App SDK method
     * @static
     * @type {number}
     * @memberof Timeouts
     */
    static SdkGlobal: number = 2 * 60 * 1000;
}